import { makePostRequest } from 'lib/axios';

const changePassword = async (payload: {
  newPassword: string;
}): Promise<any> => {
  const url = `/auth/change-password`;
  const response = await makePostRequest(url, payload);
  return response.data;
};

export default changePassword;
